import uuid from 'utils/id';

export const createNewLogicRule = (targetNode, logicRule, property) => {
    const logicId = uuid();

    return {
        ...logicRule,
        property,
        target: targetNode.id,
        targetType: targetNode.type,
        formId: targetNode.formId,
        id: logicId,
    };
};

/**
 * Returns a node assigned logicRules from a given array of formLogicRules.
 *
 * @param {[]Object} formLogicRules
 * @param {string} nodeId
 * @returns {[]Object}
 */
export const getNodeLogicRules = (formLogicRules, nodeId) =>
    formLogicRules.filter((logicRule) => logicRule.target === nodeId);
